import React, {useState, useEffect} from 'react';
import {FiLogOut, FiPlus} from 'react-icons/fi';
import {Link, useHistory} from 'react-router-dom';

import api from '../../services/api';
import {logout} from '../../auth/auth';
import urlBackend from '../../config-backend';

import logo from '../../assets/fullLogo.png';
import './styles.css';

export interface Stories {
    id: number;
    user_id: number;
    title: string;
    image: string;
    audio: string;
}

function ListStories() {
    const [stories, setStories] = useState<Stories[]>([]);

    const history = useHistory();

    useEffect(() => {
        api.get('/stories').then((response) => {
            setStories(response.data);
        });
    }, []);

    async function handleLogout() {
        logout();
        history.push('/');
    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136}/>
                <nav id="menu">
                    <Link to="/new/story">
                        <FiPlus/>
                        Adicionar história
                    </Link>
                    <a href="#" rel="noopener noreferrer" onClick={handleLogout}>
                        <FiLogOut/>
                        Sair
                    </a>
                </nav>
            </header>
            <main id="my-stories">
                <h1>Minhas histórias</h1>
                <ul className="items-grid">
                    {stories.map(item => (
                        <li key={item.id}>
                            <Link to={`/details/story/${item.id}`}>
                                <img src={`${urlBackend}/uploads/${item.image}`} className="circle" alt={item.title}
                                     width={120} height={120}/>
                                <span>{item.title}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </main>
        </div>
    );
}

export default ListStories;
